import * as types from './mutation-types'

import api from '../../../api/callcodes.js'

export const getAllCodes = async ({ commit, dispatch }) => {
  try {
    var data = await api.getAll();
    commit(types.CODES_GET_ALL, data.data)
  }
  catch (e) {
    let msg = "There was an error loading call codes.";
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const getAllCodeTypes = async ({ commit, dispatch }) => {
  try {
    var data = await api.getAllCodeTypes();
    commit(types.CODE_TYPES_GET_ALL, data.data)
  }
  catch (e) {
    let msg = "There was an error loading call codes types.";
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const getCustomerCallCodes = async ({ commit, dispatch }) => {
  try {
    var data = await api.getCustomerCallCodes();
    commit(types.CODES_GET_CUSTOMER, data.data)
  }
  catch (e) {
    let msg = "There was an error loading customer call codes, please try again.";
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};


export const setSelectedCode = async ({ commit, dispatch }, code) => {
  commit(types.SET_SELECTED_CODE, code)
};

export const saveCode = async ({ commit, dispatch }, code) => {
  return new Promise((resolve, reject) => {
    code.callCodeIVRId = parseInt(code.callCodeIVRId);
    if (code.id === 0) {
      api.create(code)
        .then(result => {
          let data = {
            title: 'Created',
            message: ' Call Code saved.',
            type: 'success'
          }
          dispatch("showNotification", data);
          dispatch("getAllCodes")
          resolve();
        })
        .catch(function () {
          let error = {
            title: 'Error',
            message: "There was an error saving the call code.",
            type: 'error'
          }
          dispatch("showNotification", error);
          reject();
        });
    }
    else {
      api.update(code)
        .then(result => {
          let data = {
            title: 'Updated',
            message: ' Call Code saved.',
            type: 'success'
          }
          dispatch("showNotification", data);
          dispatch("getAllCodes")
          resolve();
        })
        .catch(function () {
          let error = {
            title: 'Error',
            message: "There was an error saving the call code.",
            type: 'error'
          }
          dispatch("showNotification", error);
          reject();
        });
    }
  });
}



// WEBPACK FOOTER //
// ./src/store/modules/callcodes/actions.js